import * as React from "react";
import Link from 'gatsby-link';
import * as staticUrls from "../../constants/static-urls";
import styled from "styled-components";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";

interface ActionButtonBlockProps {
  /** TEXT NAD PRZYCISKIEM */
  actionButtonIntro: string

  /** TEXT NA PRZYCISKU */
  actionButtonText: string

  /** LINK DO KTÓREGO MA PRZENOSIĆ */
  actionButtonLinkTo: string

  /** marginTop ELEMENTU */
  marginTop?: number

  /** marginBottom ELEMENTU */
  marginBottom?: number

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType
}

interface ActionButtonBlockState {}

class ActionButtonBlock extends React.Component<ActionButtonBlockProps,ActionButtonBlockState> {

  constructor(props: ActionButtonBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onButtonClick() {
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  render() {
    const {actionButtonIntro,actionButtonText,actionButtonLinkTo} = this.props;
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <ActionButtonBlockWrapper className="section-padding" marginTop={this.props.marginTop} marginBottom={this.props.marginBottom}>
          <div className="container">

            <div className="text-center mt-40">
              <h2 className="mb-30 text-uppercase">{actionButtonIntro}</h2>
              <Link to={actionButtonLinkTo} className="btn btn-lg waves-effect waves-light" onClick={this.onButtonClick}>{actionButtonText}</Link>
            </div>

          </div>
        </ActionButtonBlockWrapper>
      </div>
    );
  }

}

/** STYLES => FaqBlock */

const ActionButtonBlockWrapper: any = styled.section`
  ${(props: any) => typeof props.marginTop === 'number' && `margin-top: ${props.marginTop}px !important;`}
  ${(props: any) => typeof props.marginBottom === 'number' && `margin-bottom: ${props.marginBottom}px !important;`}
  margin-top: -20px;
  padding-top: 0px !important;
  padding-bottom: 40px !important;
`;

export default ActionButtonBlock;


// WEBPACK FOOTER //
// ./src/layouts/action-button-block/action-button-block.tsx